import {ApolloCache} from '@apollo/client';

export const writeLeanNotificationReadState = (
  cache: ApolloCache<unknown>,
  notificationId: string | undefined,
  read: boolean,
) => {
  if (!notificationId) {
    return;
  }
  cache.modify({
    id: cache.identify({
      __typename: 'LeanNotificationNode',
      id: notificationId,
    }),
    fields: {read: () => read},
  });
};
